var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0172 20.8472C7.0172 22.0411 7.65375 22.9549 8.68754 23.5523C9.721 24.1492 10.9944 24.1492 12.026 23.5523C13.0601 22.9549 13.6963 22.0411 13.6963 20.8472",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3575 0C9.44661 0 8.71293 0.561603 8.71293 1.42524C8.71293 1.96883 8.69395 2.37443 8.35235 2.47832C5.44752 3.35547 3.58484 5.41146 3.58484 8.08149V12.5692C3.58484 14.6252 2.74372 15.0414 1.68517 15.8278C0.15218 16.9648 0.502136 19.3325 2.26125 19.3309H18.4532C20.2123 19.3325 20.5622 16.9648 19.0292 15.8278C17.972 15.0414 17.1296 14.6252 17.1296 12.5692V8.08149C17.1296 5.41146 15.2669 3.35547 12.3621 2.47832C12.0214 2.37443 12.0015 1.96883 12.0015 1.42524C12.0012 0.561603 11.2672 0 10.3575 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/notificationicon.309a3f4dfce5f9dd9550bec9e7f74475.svg";
export { ForwardRef as ReactComponent };